export const adminConfig = {
    getListDepartment: "/api/department/get-department",
    addUserToDepartment: "/api/department/add-user-department/{0}/{1}",
    removeUserToDepartment: "/api/department/remove-user-department/{0}/{1}",
    updateDepartmentOdds: "/api/department/update-department-odds/{0}/{1}",
};
